import React from 'react';
import { View } from 'react-native';
import { t } from 'i18n-js';
import { isPhone, isWeb } from '@helpers';
import { trackEvent, TRACKING_EVENTS } from '@services/tracking';
import useManageWallboardLevel from '@components/wallboard/hooks/useManageWallboardLevel';
import { buildWallboardLevelChangeLogTitle } from '@reducers/dataDogs/helpers';

const WallboardLevel = ({ wallboardSelectedLevel = 'live', setWallboardSelectedLevel, sendLog, Selector, navigateTitle, tourId }) => {
  const { activeTab, setActiveTab, levels } = useManageWallboardLevel({ wallboardSelectedLevel, navigateTitle });

  const webProps = isWeb && tourId ? { dataSet: { tourId } } : {};

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', width: 290, marginLeft: isPhone ? -55 : 0 }} {...webProps}>
      {levels.map((item) => (
        <Selector
          key={item.value}
          {...{
            selected: activeTab === item.value,
            variant: 'L',
            text: t(item.text),
            onPress: () => {
              trackEvent(TRACKING_EVENTS.WALLBOARD, {
                action: 'viewChanged',
                viewMode: item.value === 'live' ? 'live' : '24hDay',
              });
              setWallboardSelectedLevel(item.value);
              sendLog({ title: buildWallboardLevelChangeLogTitle(item.text), data: { item }, status: 'debug' });
              setActiveTab(item.value);
            },
          }}
        />
      ))}
    </View>
  );
};

export default WallboardLevel;
